var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "navigation-bar"
  }, [_c('div', {
    staticClass: "navigation-bar-left"
  }), _c('div', {
    key: _vm.language,
    staticClass: "navigation-bar-title"
  }, [_vm._v($t("ek3fd84", "激活账户"))]), _c('div', {
    staticClass: "navigation-bar-right"
  })]), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "flex gap-[20px] bg-[#D6FFF4] border-[#F0FAFF] border-solid border-[1px] border-[2px] rounded-md p-[10px]"
  }, [_c('div', {
    staticClass: "flex flex-col gap-2"
  }, [_c('div', {
    staticClass: "text-[16px] text-left font-500"
  }), _c('div', {
    staticClass: "text-left",
    domProps: {
      "innerHTML": _vm._s(_vm.tip)
    }
  })])]), _c('div', {
    staticClass: "set-language"
  }, [_c('div', {
    staticClass: "set-language-title"
  }, [_vm._v($t("ic4e074", "身份验证"))]), _c('div', {
    staticClass: "set-language-content"
  }, [_c('FootLanguage', {
    staticClass: "activate-language",
    attrs: {
      "placement": "bottom-end",
      "reload-on-change": false
    },
    on: {
      "change": _vm.handleLanguageChange
    }
  })], 1)]), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.unitName) + " ")]), _c('div', {
    staticClass: "scene"
  }, [_c('RadioGroup', {
    attrs: {
      "type": "button",
      "button-style": "solid"
    },
    on: {
      "on-change": _vm.changeAccountType
    },
    model: {
      value: _vm.scene,
      callback: function ($$v) {
        _vm.scene = $$v;
      },
      expression: "scene"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "phone"
    }
  }, [_vm._v($t("haa72", "手机"))]), _c('Radio', {
    attrs: {
      "label": "email"
    }
  }, [_vm._v($t("padf2", "邮箱"))])], 1)], 1), _c('div', {
    staticClass: "form"
  }, [_c('Form', {
    ref: "form",
    attrs: {
      "model": _vm.inviteInfo,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("fqmy2", "姓名"),
      "prop": "userName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": $t("2jaekd5", "请输入姓名")
    },
    model: {
      value: _vm.inviteInfo.userName,
      callback: function ($$v) {
        _vm.$set(_vm.inviteInfo, "userName", $$v);
      },
      expression: "inviteInfo.userName"
    }
  })], 1), _c('area-phone-input', {
    attrs: {
      "showPrepend": _vm.showPrepend
    },
    model: {
      value: _vm.inviteInfo,
      callback: function ($$v) {
        _vm.inviteInfo = $$v;
      },
      expression: "inviteInfo"
    }
  }), _c('FormItem', {
    attrs: {
      "prop": "captcha"
    }
  }, [_c('div', {
    staticClass: "captcha"
  }, [_c('Input', {
    attrs: {
      "placeholder": $t("7b32n16", "请输入验证码"),
      "maxlength": "6"
    },
    model: {
      value: _vm.inviteInfo.captcha,
      callback: function ($$v) {
        _vm.$set(_vm.inviteInfo, "captcha", $$v);
      },
      expression: "inviteInfo.captcha"
    }
  }), _c('Button', {
    staticClass: "getCaptcha",
    attrs: {
      "type": "primary",
      "ghost": "",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1)])], 1)], 1)]), _c('Button', {
    staticClass: "getCaptcha",
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "long": "",
      "shape": "circle"
    },
    on: {
      "click": _vm.activeAccount
    }
  }, [_vm._v($t("heqc2", "提交"))])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };